export const CUSTOMERS_GET_REQUEST = "@customers.get.request";
export const CUSTOMERS_GET_SUCCESS = "@customers.get.success";
export const CUSTOMERS_GET_FAIL = "@customers.get.failure";
export const CUSTOMERS_GET_DONE = "@customers.get.done";

export const CUSTOMER_LOAD_REQUEST = "@customer.load.request";
export const CUSTOMER_LOAD_SUCCESS = "@customer.load.success";
export const CUSTOMER_LOAD_FAIL = "@customer.load.failure";

export const CUSTOMER_CREATE_REQUEST = "@customer.create.request";
export const CUSTOMER_CREATE_SUCCESS = "@customer.create.success";
export const CUSTOMER_CREATE_FAIL = "@customer.create.failure";
export const CUSTOMER_CREATE_DONE = "@customer.create.done";

export const CUSTOMER_UPDATE_REQUEST = "@customer.update.request";
export const CUSTOMER_UPDATE_SUCCESS = "@customer.update.success";
export const CUSTOMER_UPDATE_FAIL = "@customer.update.failure";
export const CUSTOMER_UPDATE_DONE = "@customer.update.done";

export const ACTIVE_REQUEST = "@customer.active.request";
export const ACTIVE_CLEAN = "@customer.active.clean";
export const ACTIVE_SUCCESS = "@customer.active.success";
export const ACTIVE_FAIL = "@customer.active.fail";
